/**
 * Created by khanhduong on 11/9/17.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function rosterReducer(state = initialState.roster, { type, roster, options }) {
  switch (type) {
    case types.CHAT_UPDATE_ROSTER_SUCCESS: {
      const byName = {};
      let names = [];
      const friends = [];
      roster.forEach(v => {
        byName[v.name] = v;
        names = Object.keys(byName).sort();
        // eslint-disable-next-line no-unused-expressions
        isFriend(v) && friends.push(v.name);
      });
      return state.merge({
        byName,
        names,
        friends,
      });
    }
    case types.CHAT_UPDATE_MY_ROSTER_SUCCESS: {
      const byName = {};
      let names = [];
      const friends = [];
      // eslint-disable-next-line no-eval
      const roster = eval(`(${options})`);

      roster.forEach(v => {
        byName[v.name] = v;
        names = Object.keys(byName).sort();
        // eslint-disable-next-line no-unused-expressions
        isFriend(v) && friends.push(v.name);
      });
      return state.merge({
        byName,
        names,
        friends,
      });
    }
    default:
      return state;
  }
}

function isFriend(v) {
  return v.subscription !== 'none';
}
